import { render } from "./Footer.vue?vue&type=template&id=757a8b16&scoped=true&bindings={\"pathLocation\":\"data\",\"pathAccount\":\"data\",\"pathEmail\":\"data\",\"pathWhatsapp\":\"data\"}"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=757a8b16&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-757a8b16"

export default script